export default "__VITE_ASSET__DHEnaQCq__"